var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"owner-about__tabs"},[_c('h4',{staticClass:"owner-about__tabs-title"},[_vm._v("Приемка квартиры")]),_vm._v(" "),_c('TabsComponent',{attrs:{"tabsData":_vm.tabsData,"activeTab":_vm.activeTab,"type":"button"},on:{"changeTab":_vm.tabChanged}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }